import AppBase from './AppBase';

export default AppBase;
